<template>
<div class="about">
  <v-layout row>
    <v-flex md12 class="mb-1">
      <v-card :disabled="load" flat class="px-2">
        <v-layout row class="px-3">
          <v-flex md4>
            <v-list v-show="isSelectEmpresa">
            <v-list-item id="idEmpresa">
              <v-list-item-avatar>
                <v-btn color="primary" :disabled="mUnidade.nome == ''" class="white--text" @click="getUnidade({ idUnidade: 0, nome:''})"><v-icon>home_work</v-icon></v-btn>
              </v-list-item-avatar>

              <v-list-item-content @click="changeSelect()">
                <v-list-item-title v-text="mEmpresa.nomeFantasia">
                </v-list-item-title>
                <v-list-item-subtitle>Empresa</v-list-item-subtitle>
              </v-list-item-content>

              <!--v-list-item-action>
                <v-btn icon @click="changeSelect()">
                  <v-icon color="primary lighten-1">search</v-icon>
                </v-btn>
              </v-list-item-action-->
            </v-list-item>
            </v-list>
              <v-select
              v-show="!isSelectEmpresa"
                :items="[{
                    nomeFantasia: 'VITALAB MEDICINA DIAGNOSTICA',
                    id: 1
                  },
                  {
                    nomeFantasia: 'CM REMEDIOS-MEDICINA DO TRABALHO',
                    id: 7
                  },
                  {
                    nomeFantasia: 'CM REMEDIOS-SAUDE MULHER',
                    id: 9
                  },
                  {
                    nomeFantasia: 'CM REMEDIOS-MATRIZ',
                    id: 11
                  }]"
                label="Empresas"
                return-object
                v-on:change="getEmpresa"
                item-text="nomeFantasia"
              ></v-select>
            <!-- <empresas v-show="!isSelectEmpresa" v-on:empresa-select="getEmpresa"></empresas> -->
          </v-flex>
          <v-flex md4>
            <v-list v-show="mUnidade.nome != ''">
            <v-list-item id="idEmpresa">
              <v-list-item-avatar>
               <v-icon color="grey">home</v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title v-text="mUnidade.nome"></v-list-item-title>
                <v-list-item-subtitle>Unidade de negocio</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            </v-list>
          </v-flex>
          <v-flex md4>
            <v-list v-show="isSelectEmpresa">
            <v-list-item>
              <v-list-item-avatar>
               <dateForm :dataMinima="dataI" :dataMaxima="dataAtualMes" @date="carregarDados"></dateForm>
              </v-list-item-avatar>

              <v-list-item-content>
              <!-- <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-list-item-title v-text="formatDate(dataAtual)" v-on="on"></v-list-item-title>
                    </template>
                </v-tooltip> -->
                 <v-list-item-title v-text="formatDate(dataAtual)"></v-list-item-title>
                <v-list-item-subtitle>Data da consulta</v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-btn icon @click="carregarDados()">
                  <v-icon color="grey lighten-1">refresh</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            </v-list>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
    <v-flex md8 class="pr-1 pl-3">
      <v-flex md12>
        <v-row>
          <v-flex md3>
            <v-card :disabled="load" class="pt-1" outlined tile height="177">
              <div class="text-center text-bolt mx-1"><strong class="title"> Produção</strong></div>
              <div class="text-center pb-0 mb-1 amber--text text--darken-2">
                <strong>R$ {{fatura.faturaMes}}</strong></div>
              <div v-if="porcentagemMes > 0" class="text-center body-2 mx-1"><strong class="success--text"> {{porcentagemMes}}%</strong> maior (ano anterior)</div>
              <div v-if="porcentagemMes < 0" class="text-center body-2 mx-1"><strong class="red--text"> {{porcentagemMes * -1}}%</strong> menor (ano anterior)</div>
              <v-divider class="my-2"></v-divider>
              <div class="text-center body-2 text-bolt mx-1 my-1"><strong>Acumulado ({{ano}}):<br> </strong><strong class="amber--text text--darken-2">R$ {{fatura.valorTotal}}</strong></div>
            </v-card>
          </v-flex>
          <v-flex md5 row class="ml-0">
             <v-flex md6>
            <v-card :disabled="load" class outlined tile height="177">
              <strong class="d-flex justify-center pt-1 pb-0" v-text="getMes(mes)"></strong>
              <alerta :valorMes="fatura.faturaMesNum" :valorMeta="metaMes.valorMeta"></alerta>
              <v-tooltip bottom>
             <template v-slot:activator="{ on }">
              <div class="text-center subtitle-2 text-bolt" v-on="on"><strong class="amber--text text--darken-2">R$ {{formatValue(metaMes.valorMeta)}}</strong></div>
             </template>
                <span>Meta mensal</span>
              </v-tooltip>
            </v-card>
          </v-flex>
          <v-flex md6>
            <v-card :disabled="load" class outlined tile height="177">
              <strong class="d-flex justify-center pt-1 pb-0">{{ano}}</strong>
              <alerta :valorMes="metaAno.valorAcumulado" :valorMeta="metaAno.valorMeta"></alerta>
               <v-tooltip bottom>
               <template v-slot:activator="{ on }">
                <div class="text-center subtitle-2 text-bolt" v-on="on"><strong class="amber--text text--darken-2">R$ {{formatValue(metaAno.valorMeta)}}</strong></div>
               </template>
                <span>Meta anual</span>
              </v-tooltip>
            </v-card>
          </v-flex>
          </v-flex>
          <v-flex md2 class="ml-2">
            <v-card :disabled="load" class="pt-2" outlined tile height="177">
              <div class="text-center subtitle pb-0 mb-0" ><strong v-text="getMes(mes)"></strong></div>
              <div class="text-center caption pb-0 mb-0">Ordens de serviços</div>
              <div class="text-center text-bolt subtitle pb-1 mb-1 blue--text text--darken-1">
                {{fatura.qtdOSMes}}</div>
              <v-divider></v-divider>
              <div class="text-center subtitle pb-0 mb-0">Tiket médio</div>
              <div class="text-center text-bolt subtitle pb-1 mb-1 amber--text text--darken-2">
                R$ {{fatura.ticketMedioMes}}</div>
            </v-card>
          </v-flex>
          <v-flex md2>
            <v-card :disabled="load" class="pt-2" outlined tile height="177">
              <div class="text-center subtitle pb-0 mb-0"><strong v-text="ano"></strong></div>
              <div class="text-center caption pb-0 mb-0">Ordens de serviços</div>
              <div class="text-center text-bolt subtitle pb-1 mb-1 blue--text text--darken-1">
                {{fatura.qtdOS}}</div>
              <v-divider></v-divider>
              <div class="text-center subtitle pb-0 mb-0">Tiket médio</div>
              <div class="text-center text-bolt subtitle pb-1 mb-1 amber--text text--darken-2">
                R$ {{fatura.ticketMedio}}</div>
            </v-card>
          </v-flex>
          <v-flex md12>
            <v-card class="pa-2 mr-1" outlined tile>
              <faturamentoMensal v-if="idEmpresaM > 0" :tipo="1" :valorMeta="metaMes.valorMeta" :valorMinimo="metaMes.valorMinimo" :valorMetaAnual="metaAno.valorMeta" :valorMinimoAnual="metaAno.valorMinimo"  :idEmpresa="idEmpresaM" :idUnidade="idUnidadeM" :idExameEspecialidade="0" :idMedicoSolicitante="0" :dataInicio="dataI" :dataFim="dataAtual" v-on:faturamento="totalFaturado" :idConvenio="idConvenio" :idExame="idExame">
              </faturamentoMensal>
            </v-card>
          </v-flex>
        </v-row>
      </v-flex>
    </v-flex>
    <v-flex md4 class="pl-2">
      <v-row no-gutters>
        <v-col cols="12">
          <v-expansion-panels :disabled="load" accordion focusable flat>
            <v-expansion-panel>
              <v-expansion-panel-header>Unidades</v-expansion-panel-header>
              <v-expansion-panel-content class="ma-0 pa-0">
                <ranking v-on:select-unidade="getUnidade" :tipo="1" :idEmpresa="idEmpresaM" :idUnidade="idUnidadeM" :idExameEspecialidade="0" :idMedicoSolicitante="0" :dataInicio="dataAtualMes" :dataFim="dataAtual" :idConvenio="0" :idExame="0"></ranking>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>Especialidades</v-expansion-panel-header>
              <v-expansion-panel-content class="ma-0 pa-0">
                <ranking :tipo="2" :idEmpresa="idEmpresaM" :idUnidade="idUnidadeM" :idExameEspecialidade="0" :idMedicoSolicitante="0" :dataInicio="dataAtualMes" :dataFim="dataAtual" :idConvenio="0" :idExame="0"></ranking>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>Solicitantes</v-expansion-panel-header>
              <v-expansion-panel-content class="ma-0 pa-0">
                <ranking :tipo="3" :idEmpresa="idEmpresaM" :idUnidade="idUnidadeM" :idExameEspecialidade="0" :idMedicoSolicitante="0" :dataInicio="dataAtualMes" :dataFim="dataAtual" :idConvenio="0" :idExame="0"></ranking>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>Convênios</v-expansion-panel-header>
              <v-expansion-panel-content class="ma-0 pa-0">
                <ranking :tipo="4" :idEmpresa="idEmpresaM" :idUnidade="idUnidadeM" :idExameEspecialidade="0" :idMedicoSolicitante="0" :dataInicio="dataAtualMes" :dataFim="dataAtual" :idConvenio="0" :idExame="0"></ranking>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import faturamentoMensal from './../components/faturamento/faturamentoMensal'
import ranking from './../components/faturamento/ranking'
import alerta from './../components/faturamento/alerta'
import dateForm from './../components/faturamento/dateForm'
// import empresas from './../components/filtros/components/empresas'
import service from './../services/metaservice'
// eslint-disable-next-line no-unused-vars
import filtro from './../components/filtros/filtroFaturamento'
import {
  EventBus
} from './../main'
export default {
  data () {
    return {
      dados: '',
      isSelectEmpresa: false,
      dataAtual: '',
      dataAtualMes: '',
      idConvenio: 0,
      idExame: 0,
      ano: '',
      mes: '',
      metaAno: {
        valorMeta: 0,
        valorMinimo: 0,
        valorAcumulado: 0
      },
      metaMes: {
        valorMeta: 0,
        valorMinimo: 0
      },
      dataI: '',
      meta: null,
      idEmpresaM: 0,
      idUnidadeM: 0,
      mUnidade: {
        nome: '',
        id: 0
      },
      mEmpresa: {
        nome: '',
        id: 0
      },
      fatura: {
        ticketMedio: 0,
        ticketMedioMes: 0,
        valorTotal: 0,
        qtdOS: 0,
        qtdOSMes: 0,
        faturaMes: 0
      },
      porcentagemMes: 0,
      params: null,
      load: false,
      dateConsulta: null
    }
  },
  components: {
    dateForm,
    alerta,
    faturamentoMensal: faturamentoMensal,
    // filtro: filtro,
    ranking
  },
  methods: {
    computerBtnLoad (i) {
      this.btnLoad = this.btnLoad - i
      if (this.btnLoad === 0) {
        EventBus.$emit('loadStop', false)
      }
    },
    computerBtnLoadStart (i) {
      this.btnLoad = this.btnLoad + 1
    },
    changeSelect () {
      // this.limparDados()
      this.fatura = {
        ticketMedio: 0,
        ticketMedioMes: 0,
        valorTotal: 0,
        qtdOS: 0,
        qtdOSMes: 0,
        faturaMes: 0,
        faturaMesNum: 0
      }
      this.metaMes.valorMeta = 0
      this.metaAno.valorMeta = 0
      this.mUnidade = {
        nome: '',
        id: 0
      }
      this.porcentagemMes = 0
      this.metaAno.valorAcumulado = 0
      this.metaAno.valorTotal = 0
      // this.idUnidadeM = 0
      this.isSelectEmpresa = false
    },
    clear () {
      this.fatura = {
        ticketMedio: 0,
        ticketMedioMes: 0,
        valorTotal: 0,
        qtdOS: 0,
        qtdOSMes: 0,
        faturaMes: 0,
        faturaMesNum: 0
      }
      this.metaMes.valorMeta = 0
      this.metaAno.valorMeta = 0
      this.porcentagemMes = 0
      this.metaAno.valorAcumulado = 0
      // th
    },
    getUnidade (data) {
      this.limparDados()
      this.mUnidade = data
      this.idUnidadeM = data.idUnidade
      this.carregarMetas()
    },
    getEmpresa (empresa) {
      this.dateConsulta = new Date()
      this.isSelectEmpresa = true
      this.mEmpresa = empresa
      this.idEmpresaM = empresa.id
      this.carregarMetas()
    },
    carregarMetas () {
      // this.clear()
      this.load = true
      service.listarMetas({
        idEmpresa: this.idEmpresaM,
        idUnidade: this.idUnidadeM,
        dataInicial: this.dataAtual,
        dataFinal: this.dataI
      }).then(r => {
        if (r.status === 200) {
          if (r.data.status === 1) {
            this.meta = r.data.empresa.anos[0]
            this.metaAno.valorMeta = this.convertStringToNumber(this.meta.valorMeta)
            this.metaAno.valorMinimo = this.convertStringToNumber(this.meta.valorMinimo)
            for (let i = 0; i < this.meta.meses.length; i++) {
              const m = this.meta.meses[i]
              if (m.mes === this.mes) {
                /* var v1 = m.valorMeta.split(' ')
                var v2 = m.valorMinimo.split(' ')
                let m1 = v1[1].split('')
                let m2 = v2[1].split('')
                let valor1 = ''
                let valor2 = ''
                for (let j = 0; j < m1.length; j++) {
                  const c = m1[j]
                  if (c !== '.' && c !== ',') {
                    valor1 = valor1 + c
                  }
                }
                for (let j = 0; j < m2.length; j++) {
                  const c = m2[j]
                  if (c !== '.' && c !== ',') {
                    valor2 = valor2 + c
                  }
                } */
                this.metaMes.valorMeta = this.convertStringToNumber(m.valorMeta)
                this.metaMes.valorMinimo = this.convertStringToNumber(m.valorMinimo)
                console.log(this.metaMes)
              }
            }
          }
        }
      }).finally(() => {
        this.load = false
      })
    },
    convertStringToNumber (data) {
      var v1 = data.split(' ')
      let m1 = v1[1].split('')
      let valor1 = ''
      for (let j = 0; j < m1.length - 2; j++) {
        const c = m1[j]
        if (c !== '.' && c !== ',') {
          valor1 = valor1 + c
        }
      }
      return Number(valor1)
    },
    limparDados () {
      this.fatura = {
        ticketMedio: 0,
        valorTotal: 0,
        qtdOS: 0,
        faturaMes: 0

      }
      this.mUnidade = {
        nome: '',
        id: 0
      }
      this.idUnidadeM = 0
      this.porcentagemMes = 0
    },
    formatDate (data) {
      let date = new Date(data)
      // return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}`
      return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`
    },
    carregarDados (data) {
      this.clear()
      var dataAtual = ''
      if (data != null) {
        dataAtual = new Date(data)
        this.dataAtual = `${dataAtual.getFullYear()}-${dataAtual.getMonth() + 1}-${dataAtual.getDate() + 1} 23:59:59`
      } else {
        dataAtual = new Date()
        this.dataAtual = `${dataAtual.getFullYear()}-${dataAtual.getMonth() + 1}-${dataAtual.getDate()} 23:59:59`
      }
      // console.log(`${dataAtual.getFullYear()}-${dataAtual.getMonth() + 1}-${dataAtual.getDate()}`)
      this.dataAtualMes = `${dataAtual.getFullYear()}-${dataAtual.getMonth() + 1}-1 00:00:00`
      this.dataI = `${dataAtual.getFullYear() - 1}-1-1 00:00:00`
      this.mes = dataAtual.getMonth() + 1
      this.ano = dataAtual.getFullYear()
      // this.params = dados
      // this.carregarAnalise(dados)
    },
    totalFaturado (data) {
      this.metaAno.valorAcumulado = data.valorTotal
      this.fatura = {
        ticketMedioMes: this.formatValue(data.ticketMedioMes),
        ticketMedio: this.formatValue(data.ticketMedio),
        valorTotal: this.formatValue(data.valorTotal),
        qtdOS: this.formatDigit(data.qtdOS),
        qtdOSMes: this.formatDigit(data.qtdOSMes),
        faturaMes: this.formatValue(data.faturaMes),
        faturaMesNum: data.faturaMes,
        faturaMesAnterior: this.formatValue(data.faturaMesAnterior)
      }
      // let mesAnterior = parcerInt(data.faturaMesAnterior)
      let paux = parseInt(data.faturaMesAnterior)
      if (paux === 0) { paux = 1 }
      let p1 = (parseInt(data.faturaMes) / paux) * 100
      this.porcentagemMes = this.formatDigit(p1 - 100)
    },
    formatValue (value) {
      const val = Number(value.toString().replace(',', '.'))
      if (!val) return '0,00'
      const valueString = val.toFixed(2).replace('.', ',')
      return valueString.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    formatDigit (value) {
      const val = Number(value.toString().replace(',', '.'))
      if (!val) return '0'
      const valueString = val.toFixed().replace('.', '.')
      return valueString.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    removeCharacter (simbolo, caracter) {
      let reg = new RegExp(simbolo)
      return caracter.replace(reg, '')
    },
    getMes (mes) {
      let meses = [
        { mes: 1,
          nome: 'Janeiro',
          valorMinimo: '',
          valorMeta: '' },
        { mes: 2,
          nome: 'Fevereiro',
          valorMinimo: '',
          valorMeta: '' },
        { mes: 3,
          nome: 'Março',
          valorMinimo: '',
          valorMeta: '' },
        { mes: 4,
          nome: 'Abril',
          valorMinimo: '',
          valorMeta: '' },
        { mes: 5,
          nome: 'Maio',
          valorMinimo: '',
          valorMeta: '' },
        { mes: 6,
          nome: 'Junho',
          valorMinimo: '',
          valorMeta: '' },
        { mes: 7,
          nome: 'Julho',
          valorMinimo: '',
          valorMeta: '' },
        { mes: 8,
          nome: 'Agosto',
          valorMinimo: '',
          valorMeta: '' },
        { mes: 9,
          nome: 'Setembro',
          valorMinimo: '',
          valorMeta: '' },
        { mes: 10,
          nome: 'Outubro',
          valorMinimo: '',
          valorMeta: '' },
        { mes: 11,
          nome: 'Novembro',
          valorMinimo: '',
          valorMeta: '' },
        { mes: 12,
          nome: 'Dezembro',
          valorMinimo: '',
          valorMeta: '' }
      ]
      let mMes = null
      for (let i = 0; i < meses.length; i++) {
        const e = meses[i]
        if (e.mes === mes) {
          mMes = e
          break
        }
      }
      return mMes.nome
    },
    computerLoad (i) {
      this.load = i
    }
  },
  watch: {
    idEmpresaM: function (val) {
      this.limparDados()
    }
    // idUnidadeM: function (val) { this.carregarDados() }
  },
  mounted () {
    this.carregarDados()
    EventBus.$on('load', this.computerLoad)
  }
}
</script>

<style scoped>
  #idEmpresa {
    cursor: pointer
  }
</style>
